import React from 'react';
import './Style/Footer.css';

const Footer = () => {

 
    return (
        <>



                <footer className="computer-only-footer">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h3>Preparation</h3>
                            <ul>
                                <li><a href="/practice-questions">JEE Practice Questions (DPP)</a></li>
                                <li><a href="/previous-year-questions">JEE Previous Year Questions</a></li>
                                <li><a href="/quiz">JEE Repeated Questions</a></li>
                            </ul>
                        </div>



                        <div className="footer-section">
                            <h3>JEE Exam</h3>
                            <ul>
                                <li><a href="/syllabus">JEE Syllabus</a></li>
                                <li><a href="/chapter-wise-weightage">Topic-wise Weightage</a></li>
                                <li><a href="/previous-year-questions">JEE Previous Year Questions</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h3>Support</h3>
                            <ul>
                                <li><a href="/about">About Us</a></li>
                                <li><a href="/contact">Contact Us</a></li>
                                <li><a href="/privacy-policy">Privacy Policy</a></li>
                                <li><a href="/terms-conditions">Terms & Conditions</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h3>Connect With Us</h3>

                            <div className="app-download">
                                <p>Download Our App</p>
                                <div className="download-links">
                                    <a href="https://play.google.com/store/apps/details?id=com.mystudyplace.westbengalexam" target='_blank' className="app-link">Google Play</a>
                                    <a href="https://play.google.com/store/apps/details?id=com.mystudyplace.westbengalexam" target='_blank' className="app-link">App Store</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <div className="footer-bottom-content">
                            <p>&copy; {new Date().getFullYear()} JEE Prep App. All rights reserved.</p>
                            <div className="legal-links">
                                <a href="/privacy-policy">Privacy Policy</a>

                            </div>
                        </div>
                    </div>

                </footer>
           

        </>
    );
};

export default Footer;